export default {
  init() {
    // JavaScript to be fired on the used single page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    /* Finance Popup */
    jQuery('.finance__popup-btn').on('click', function() {
      jQuery('body').toggleClass('overflow-hidden');
      jQuery('.finance__popup-content').toggleClass('open');
    });

    /* If popup is open and user clicks on the overlay then remove the open class */
    jQuery('.finance__popup-content').on('click', function(e) {
      if ( e.target === this && jQuery(this).hasClass('open') ) {
        jQuery(this).removeClass('open');
        jQuery('body').removeClass('overflow-hidden');
      }
    })
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/singleUsed.js